export default __webpack_public_path__ + "static/media/Report_vector.445d5dbd.svg";